import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer, SimpleChanges, ViewChild } from '@angular/core';

import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';
import { ModalDirective } from 'ngx-bootstrap';
import { Principal } from 'src/app/core/auth/principal.service';
import { StateStorageService } from 'src/app/core/auth/state-storage.service';
import { LoginService } from 'src/app/core/login/login.service';
import { ConfirmationModelService } from '../confirmation-modal/confirmation-model.service';
import { LanguageChangeService } from '../services/language-change.service';
import { RoleUtil } from '../util/role-util';
import { FutureHistoryService } from './future-history.service';


@Component({
  selector: 'jhi-future-history',
  templateUrl: './future-history.component.html',
  // styleUrls: ['./future-history.component.scss']
})
export class FutureHistoryComponent implements OnChanges, OnInit {
  @ViewChild('staticModal') staticModal: ModalDirective;

  @Output() readToggleEvent = new EventEmitter<boolean>();
  // @Input() historyList = [];
  @Input() title: string;
  @Input() htype: string;
  @Input() type: string;
  @Input() id: number;

  historyList = [];

  totalItems: any;
  queryCount: any;
  itemsPerPage: any = 5;
  page: any = 1;
  predicate: any;
  previousPage: any;
  reverse: any;
  searchText: string;
  flag: boolean;

  selectedDeleteId: number;
  selectedDeleteMasterId: number;
  isConfirmed: boolean = false;

  // @Input() historyList = [];
  @Input() readToggleBooleanFutureHistory = true;
  isClosingTab: boolean = false;
  selectedfromEffectiveDate: string;
  selectedDeleteType: any;
  deletionMessage: string;
  isConfirmDeletion: any;
  isShowDeleteButton: boolean = false;
  adminList: string[] = ['BROKER_AUDIT', 'INSURER_AUDIT', 'UNDERWRITER_USER_AUDIT', 'INTERNAL_STAFF_AUDIT'];
  constructor(
    private jhiAlertService: JhiAlertService,
    private eventManager: JhiEventManager,
    public activeModal: NgbActiveModal,
    private loginService: LoginService,
    private stateStorageService: StateStorageService,
    private elementRef: ElementRef,
    private renderer: Renderer,
    private router: Router,
    public principal: Principal,
    private historyService: FutureHistoryService, // public activeModal: NgbActiveModal,
    private ref: ChangeDetectorRef,
    private confirmationModelService: ConfirmationModelService,
    private languageChangeService: LanguageChangeService,
    private activatedRoute: ActivatedRoute,

  ) { 
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
  }

  ngOnInit(): void {
    // throw new Error("Method not implemented.");
    this.showButtons();
  }

  showButtons() {
    this.isShowDeleteButton = false;
    if (this.principal.hasAnyAuthorityDirect(RoleUtil.ClientBrokerUnderwriterInsurerAuthorities)) {
      this.isShowDeleteButton = true;
    } else if (this.principal.hasAnyAuthorityDirect(['ROLE_ADMIN', 'ADMIN_STAFF']) && this.adminList.indexOf(this.type) > -1) {
      this.isShowDeleteButton = true;
    }
  }


  historyToggle() {
    // this.isClosingTab = true;
    this.readToggleBooleanFutureHistory = false;
    this.principal.isHistoryFuturePopupShown=false
    this.readToggleEvent.emit(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.showButtons();
    // console.log(changes);
    // console.log(this.title);
    // console.log(this.type);
    // console.log(this.id);
    if (this.readToggleBooleanFutureHistory) {
      this.page = 1;
      this.previousPage = 0;
      this.historyList = [];
      if (this.id != null && this.id != undefined && this.readToggleBooleanFutureHistory) {
        this.getHistoryByType();
      }
    }
  }

  getHistoryByType() {

    let pageObject = {
      page: this.page - 1,
      size: this.itemsPerPage,
      // sort: this.sort()
    }

    let for_data = {
      auditLogType: this.type,
      auditLogId: this.id,
    }

    this.historyService.getFutureAuditLogByTypeForDataManagement(pageObject, for_data).subscribe(response => {
      // console.log(response);
      this.historyList = response.body.auditLogDTOList;
      this.principal.isHistoryFuturePopupShown = true;
      this.principal.showContent=true;
      this.paginateSurveyAssociations(response.headers);
      this.ref.detectChanges();
    });
  }



  loadPage(page) {
    if (page !== this.previousPage) {
      this.previousPage = page;
    }
    this.getHistoryByType();
  }

  sort() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  private paginateSurveyAssociations(headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
  }




  showConfirmModelForDeleteFutureRecord(id, masterId, fromEffectiveDate, futureRType) {
    // console.log(id);
    this.selectedDeleteId = id;
    this.selectedDeleteMasterId = masterId;
    this.selectedDeleteType = futureRType;
    const dateFormatter = fromEffectiveDate.split("-");
   // this.selectedfromEffectiveDate = dateFormatter[2] + "-" + dateFormatter[1] + "-" + dateFormatter[0];
  let month= "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dateFormatter[1] ) / 3 + 1;
   this.selectedfromEffectiveDate = dateFormatter[2] + "-" + month + "-" + dateFormatter[0];
    let form_data = {
      masterId: masterId,
      futureDataType: futureRType,
      fromEffectiveDateFormatted: this.selectedfromEffectiveDate
    }
    this.deletionMessage = this.selectedfromEffectiveDate;
    this.getExistedRecordBasedOnDeleteRecord(form_data);

  }

  getExistedRecordBasedOnDeleteRecord(form_data) {
    this.isConfirmDeletion = false;
    this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
      const resBody = response.body;
      // console.log(resBody);
      if (resBody.isSuccess) {
        this.deletionMessage = this.selectedfromEffectiveDate + ", " + resBody.message;
        this.isConfirmDeletion = true;
      }
      this.staticModal.show();
    });
  }

  confirmDeleteFutureRecord() {
    // console.log(this.selectedDeleteId + " : " + this.selectedDeleteMasterId);
    this.isConfirmed = true;
    this.historyService.deleteFutureAuditLog(this.selectedDeleteId, this.selectedDeleteMasterId, this.type).subscribe(response => {
      // console.log(response);
      if (response.body.isSuccess) {
        this.jhiAlertService.success(response.body.message);
        this.deleteExistedFutureRecordDetails();
      } else {
        this.jhiAlertService.error(response.body.message);
      }
      this.isConfirmed = false;
      this.staticModal.hide();
    });
  }

  deleteExistedFutureRecordDetails() {
    if (this.isConfirmDeletion) {
      let form_data = {
        masterId: this.selectedDeleteMasterId,
        futureDataType: this.selectedDeleteType,
        fromEffectiveDateFormatted: this.selectedfromEffectiveDate
      }
      this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
        // console.log(response);
        this.isConfirmDeletion = false;

        this.page = 1;
        this.previousPage = 0;
        this.historyList = [];
        this.getHistoryByType();
      });
    } else {
      this.page = 1;
      this.previousPage = 0;
      this.historyList = [];
      this.getHistoryByType();
    }
  }



}
